import React, { useCallback } from "react";
import NiceModal from "@ebay/nice-modal-react";
import { CommissioningCostModal } from "components";
import { Icon } from "components/Icon/Icon";
import { useTranslate } from "hooks";

type CommissioningCostNodeProps = {
  nodeId: string | null;
  isActive: boolean;
};

export const CommissioningCostNode = ({
  nodeId,
  isActive,
}: CommissioningCostNodeProps) => {
  const translate = useTranslate();

  const handleAddServicesBtn = useCallback(() => {
    NiceModal.show(CommissioningCostModal, { nodeId: nodeId! });
  }, [nodeId]);

  return (
    <div
      className="d-flex flex-row align-items-center gap-2 flex-grow-1 overflow-hidden"
      style={{ minWidth: 0 }}
    >
      <Icon
        iconName="file-invoice-dollar-regular"
        className="icon-16 flex-shrink-0"
      />
      <span className="fw-bold fs-md text-truncate">
        {isActive
          ? translate("WIZARD_COMMISSIONING")
          : translate("WIZARD_WITHOUT_COMMISSIONING")}
      </span>
      <span
        className="ms-2 text-blue-300 cursor-pointer"
        onClick={handleAddServicesBtn}
      >
        {translate("SELECT")}
      </span>
    </div>
  );
};
